export const REGISTRATION_FORM_ENDPOINTS = {
  submit: "/demo-api/registration-form/submit",
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function submitRegistrationForm(payload) {
  await wait(700);

  return {
    success: true,
    endpoint: REGISTRATION_FORM_ENDPOINTS.submit,
    message: "Registration form submitted successfully.",
    data: {
      id: `REG-${Date.now()}`,
      ...payload,
    },
  };
}
